// extracted by mini-css-extract-plugin
export default {"documentWrapper":"EledoXfaEditor_documentWrapper__CX25a"};